<template>
  <VCardImportFormSection title="Office Info">
    <v-row>
      <v-col cols="4">
        Office City
      </v-col>
      <v-col cols="8">
        <VCardImportSelect
          v-model="parsedData.office_address.city"
          :items="items"
        />
      </v-col>
      <v-col cols="4">
        Office Postal
      </v-col>
      <v-col cols="8">
        <VCardImportSelect
          v-model="parsedData.office_address.postal"
          :items="items"
        />
      </v-col>
      <v-col cols="4">
        Office State
      </v-col>
      <v-col cols="8">
        <VCardImportSelect
          v-model="parsedData.office_address.state"
          :items="items"
        />
      </v-col>
      <v-col cols="4">
        Office Street
      </v-col>
      <v-col cols="8">
        <VCardImportSelect
          v-model="parsedData.office_address.street"
          :items="items"
        />
      </v-col>
    </v-row>
  </VCardImportFormSection>
</template>

<script lang="ts">
import mixins from 'vue-typed-mixins';

import { VCardSectionMixin } from '@/bundles/Contact/mixins/VCardSectionMixin';

export default mixins(VCardSectionMixin).extend({
  name: 'VCardImportOfficeInfo',
});
</script>
